import { connect } from 'react-redux'
import { currentUserProvider } from './CurrentUser__Context.bs'

export default connect(state => ({
  token: state.session.token,
  initializationStatus: state.session.initializationStatus,
}))(currentUserProvider)
